export const types = [
  '/estimationFolderShow/rejected'
]
